import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import { toRoman } from '../../formatting.js';
import { getClassClanLeverWrapper } from '../../helpers/supply.js';
import styles from './ClanLevel.module.scss.js';

var ClanLevel = (function (_super) {
    __extends(ClanLevel, _super);
    function ClanLevel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClanLevel.prototype.render = function () {
        var classClanLeverWrapper = getClassClanLeverWrapper(this.props.clanLevel);
        var classNameBase = styles["clan-level-wrapper-" + classClanLeverWrapper];
        return (React.createElement("div", { className: classNames(classNameBase, this.props.className) },
            React.createElement("div", { className: styles.levelRomain }, toRoman(this.props.clanLevel))));
    };
    return ClanLevel;
}(React.PureComponent));

export { ClanLevel, ClanLevel as default };
//# sourceMappingURL=ClanLevel.js.map
